<template>
    <section class="section-keep-watching">
        <v-container v-if="!loading" id="keep-watching-section">
            <h2 class="section-keep-watching__title">Continue assistindo</h2>
            <KeepWatchingCard
                :id="keepWatchingVideo.id"
                :image="keepWatchingVideo.image"
                :title="keepWatchingVideo.title"
                :description="keepWatchingVideo.description"
            />
        </v-container>
    </section>
</template>

<script>
    import KeepWatchingCard from './KeepWatchingCard.vue';
    import lessonApi  from '@/utils/portal/lesson';
    import Loader from '@/components/Loader/loader.vue';
    import { mapState, mapActions } from 'vuex';
    

    export default {
        name: 'KeepWatchingSection',
        components: {
            KeepWatchingCard,
            Loader,
        },
        computed: {
            ...mapState(['token']),
        },
        data() {
            return {
                keepWatchingVideo: {
                    id: '',
                    image: '',
                    title: '',
                    description: '',
                },
                loading: true,
            };
        },
        created() {
            this.getLatestCourse();
        },
        methods: {
            ...mapActions(['storeLatestCourse','storeCurrentCoursePortal']),
            async getLatestCourse() {
                this.loading = true;
                try {
                    const response = await lessonApi.getLatestCourse(this.token);
                    this.storeLatestCourse({ latestCourse: response });
                    this.storeCurrentCoursePortal({ currentCoursePortal: response });
                    this.keepWatchingVideo.id = response.id;
                    this.keepWatchingVideo.image = response.course.imageFinalPath2;
                    this.keepWatchingVideo.title = response.course.name;
                    this.keepWatchingVideo.description = response.course.shortDescription;
                    console.debug(response, 'response');
                } catch (error) {
                    console.error('Erro ao carregar último curso local:', error);
                } finally {
                    this.loading = false;
                }
            }
        }
    };
</script>

<style scoped>
    .section-keep-watching {
        padding: 8px 0 28px;
        position: relative;
        background-color: transparent;
    }
    .dark .section-keep-watching {
        background-color: transparent;
    }
    .section-keep-watching__title {
        font-size: 20px;
        font-weight: 700;
        margin: 0 0 14px;
        color: var(--dash-text, #111827);
        text-align: left;
        letter-spacing: -0.02em;
    }
    .dark .section-keep-watching__title {
        color: var(--dash-text, #f3f4f6);
    }
    @media (max-width: 768px) {
        .section-keep-watching {
            padding: 0 !important;
        }
        div#keep-watching-section {
            max-width: 100%!important;
            margin: 0 auto!important;
        }
    }
    div#keep-watching-section {
        max-width: 1600px;
        margin: 0 auto;
    }
</style>
